/* eslint-disable no-undef */
// Initialize quick-view interactions after modal content is injected
function initQuickViewProduct (container) {
  if (!container) return

  // Build image list from thumbnails and dots
  const thumbnails = Array.from(container.querySelectorAll('.sd-qv__thumbnail'))
  const dots = Array.from(container.querySelectorAll('.sd-qv__dot'))
  const mainImage = container.querySelector('.sd-qv__main-image')
  const mobileImage = container.querySelector('.sd-qv__mobile-image')
  let currentIndex = 0
  const imageCount = Math.max(thumbnails.length, dots.length)

  function goToImage (index) {
    if (index < 0) index = imageCount - 1
    if (index >= imageCount) index = 0
    currentIndex = index

    // Update desktop main image from thumbnail data
    if (thumbnails[index] && mainImage) {
      mainImage.src = thumbnails[index].getAttribute('data-full-src')
      mainImage.alt = thumbnails[index].alt
    }
    thumbnails.forEach(function (t) { t.classList.remove('active') })
    if (thumbnails[index]) thumbnails[index].classList.add('active')

    // Update mobile image from dot data
    if (dots[index] && mobileImage) {
      mobileImage.src = dots[index].getAttribute('data-full-src')
    }
    dots.forEach(function (d) { d.classList.remove('active') })
    if (dots[index]) dots[index].classList.add('active')
  }

  // Thumbnail click
  thumbnails.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { goToImage(i) })
  })

  // Dot click
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goToImage(i) })
  })

  // Desktop arrow navigation
  container.querySelectorAll('.sd-qv__arrow').forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      if (arrow.getAttribute('data-arrow') === 'prev') {
        goToImage(currentIndex - 1)
      } else {
        goToImage(currentIndex + 1)
      }
    })
  })

  // Mobile swipe on image
  if (mobileImage) {
    let touchStartX = 0
    let touchEndX = 0
    const swipeThreshold = 40

    mobileImage.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX
    }, { passive: true })

    mobileImage.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].clientX
      const diff = touchStartX - touchEndX
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          goToImage(currentIndex + 1)
        } else {
          goToImage(currentIndex - 1)
        }
      }
    }, { passive: true })
  }

  // Variant option pill selection UI + price update
  const variantSelects = container.querySelector('variant-selects')
  const priceElements = container.querySelectorAll('.sd-qv__price')
  let variants = []

  if (variantSelects) {
    const variantJson = variantSelects.querySelector('script[type="application/json"]')
    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent) } catch (e) {}
    }
  }

  container.querySelectorAll('.sd-qv__variant-option').forEach(function (label) {
    label.addEventListener('click', function () {
      const parent = label.closest('.sd-qv__variant-options')
      parent.querySelectorAll('.sd-qv__variant-option').forEach(function (l) {
        l.classList.remove('selected')
      })
      label.classList.add('selected')

      // Match selected options to a variant and update price
      if (variants.length > 0) {
        const selectedOptions = []
        container.querySelectorAll('.sd-qv__variants').forEach(function (fieldset) {
          const checked = fieldset.querySelector('input:checked')
          if (checked) selectedOptions.push(checked.value)
        })

        const matched = variants.find(function (v) {
          return selectedOptions.every(function (opt, i) {
            return v.options[i] === opt
          })
        })

        if (matched) {
          const formattedPrice = window.Shopify && Shopify.formatMoney
            ? Shopify.formatMoney(matched.price)
            : '$' + (matched.price / 100).toFixed(2)
          let priceHtml = ''
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            const formattedCompare = window.Shopify && Shopify.formatMoney
              ? Shopify.formatMoney(matched.compare_at_price)
              : '$' + (matched.compare_at_price / 100).toFixed(2)
            priceHtml = '<s>' + formattedCompare + '</s> ' + formattedPrice
          } else {
            priceHtml = formattedPrice
          }
          priceElements.forEach(function (el) { el.innerHTML = priceHtml })

          // Update add to cart button state
          const submitBtn = container.querySelector('.sd-qv__submit')
          const submitSpan = submitBtn ? submitBtn.querySelector('span') : null
          const variantInput = container.querySelector('input.product-variant-id')
          if (submitBtn && submitSpan) {
            if (matched.available) {
              submitBtn.disabled = false
              submitSpan.textContent = 'Add to Cart'
              if (variantInput) { variantInput.disabled = false }
            } else {
              submitBtn.disabled = true
              submitSpan.textContent = 'Sold Out'
              if (variantInput) { variantInput.disabled = true }
            }
          }
        }
      }
    })
  })
}

// Listen for modal content being injected — MutationObserver on all quick-add-modals
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('quick-add-modal').forEach(function (modal) {
    const contentInfo = modal.querySelector('.quick-add-modal__content-info')
    if (!contentInfo) return

    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          const productInfo = contentInfo.querySelector('product-info')
          if (productInfo && productInfo.querySelector('.sd-qv')) {
            initQuickViewProduct(productInfo)
            // Re-trigger Affirm to scan newly injected elements
            if (window.affirm && affirm.ui && affirm.ui.refresh) {
              affirm.ui.refresh()
            }
          }
          break
        }
      }
    })

    observer.observe(contentInfo, { childList: true })
  })
})
